<script>
  import { page } from "$app/stores";
  import { variables } from "$lib/variables";
  import { onMount } from "svelte";
  import { fade, fly } from "svelte/transition";
  export let openConfirmAddBasketSize, item, AddBasketVariant, AddWatchList;
  let selected = item.id;
  function onChange(event) {
    selected = Number(event.currentTarget.value);
  }
  onMount(async () => {});
  function SaveData() {
    AddBasketVariant(selected);
  }
</script>

<div class="relative z-[100000]" role="dialog" aria-modal="true">
  <div
    class="fixed inset-0 hidden bg-gray-500 bg-opacity-75 transition-opacity md:block"
  />

  <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div
      class="flex min-h-full items-stretch justify-center text-center md:items-center md:px-2 lg:px-4"
    >
      <div
        class="flex w-full transform text-left text-base transition md:my-8 md:max-w-2xl md:px-4 lg:max-w-4xl"
      >
        <div
          transition:fly
          class="relative flex w-full items-center overflow-hidden bg-white px-4 pb-8 pt-14 shadow-2xl sm:px-6 sm:pt-8 md:p-6 lg:p-8"
        >
          <button
            on:click={() => {
              openConfirmAddBasketSize = false;
            }}
            type="button"
            class="absolute right-4 top-4 text-gray-400 hover:text-gray-500 sm:right-6 sm:top-8 md:right-6 md:top-6 lg:right-8 lg:top-8"
          >
            <span class="sr-only">Close</span>
            <svg
              class="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>

          <div
            class="grid w-full grid-cols-1 items-start gap-x-6 gap-y-8 sm:grid-cols-12 lg:gap-x-8"
          >
            <div
              class="aspect-h-3 aspect-w-2 overflow-hidden rounded-lg bg-gray-100 sm:col-span-4 lg:col-span-5"
            >
              <img
                src={item.photos[0].image}
                alt="Two each of gray, white, and black shirts arranged on table."
                class="object-cover object-center"
              />
            </div>
            <div class="sm:col-span-8 lg:col-span-7">
              <h2 class="text-2xl font-bold text-gray-900 sm:pr-12">
                {item.product[`name${$page.data.host}`]}
              </h2>

              <section aria-labelledby="information-heading" class="mt-2">
                <h3 id="information-heading" class="sr-only">
                  Product information
                </h3>

                <p class="text-2xl text-gray-900">
                  {#if !item.pre_order}
                    {#if Number(item.sale_price) != 0}
                      <span class="text-sm text-custom-black">
                        <span style="font-weight: 600;"
                          >{Number(item.sale_price).toLocaleString("ru")}</span
                        >
                        ₽
                      </span>
                      <span
                        class="text-sm mr-[4px] line-through text-custom-gray"
                      >
                        {Number(item.price).toLocaleString("ru")}
                        ₽
                      </span>
                    {:else}
                      <span class="text-sm mr-[4px] text-custom-black">
                        <span style="font-weight: 600;"
                          >{Number(item.price).toLocaleString("ru")}</span
                        >
                        ₽
                      </span>
                    {/if}
                  {:else}
                    {Number(item.price_pre_order).toLocaleString("ru")} ₽
                  {/if}
                </p>
              </section>

              <section aria-labelledby="options-heading" class="mt-10">
                <h3 id="options-heading" class="sr-only">Product options</h3>

                <form on:submit|preventDefault={SaveData}>
                  <!-- Colors -->

                  <!-- Sizes -->
                  <div class="mt-10">
                    <div class="flex items-center justify-between">
                      <h4 class="text-sm font-medium text-gray-900">Размеры</h4>
                    </div>

                    <fieldset class="mt-4">
                      <legend class="sr-only">Choose a size</legend>
                      <div class="grid grid-cols-4 gap-4">
                        <!-- Active: "ring-2 ring-indigo-500" -->
                        {#each item.get_sizes_origin_product as size}
                          {#if size.total > 0}
                            <div class="pb-1">
                              <label
                                class:border-indigo-500={selected === size.id}
                                class="group relative flex items-center justify-center rounded-md border py-3 px-4 text-sm font-medium uppercase hover:bg-gray-50 focus:outline-none sm:flex-1 cursor-pointer bg-white text-gray-900 shadow-sm"
                              >
                                <input
                                  checked={selected === size.id}
                                  on:change={onChange}
                                  type="radio"
                                  name="size-choice"
                                  value={size.id}
                                  class="sr-only"
                                  aria-labelledby="size-choice-0-label"
                                />
                                <span id="size-choice-0-label"
                                  >{size.sizes.european ||
                                    size.sizes.international}</span
                                >

                                <span
                                  class="pointer-events-none absolute -inset-px rounded-md"
                                  aria-hidden="true"
                                />
                              </label>
                            </div>
                          {:else}
                            <div>
                              <label
                                class="group relative flex items-center justify-center rounded-md border py-3 px-4 text-sm font-medium uppercase hover:bg-gray-50 focus:outline-none sm:flex-1 cursor-not-allowed bg-gray-50 text-gray-200"
                              >
                                <input
                                  type="radio"
                                  name="size-choice"
                                  value="XXXL"
                                  disabled
                                  class="sr-only"
                                  aria-labelledby="size-choice-7-label"
                                />
                                <span id="size-choice-7-label"
                                  >{size.sizes.european ||
                                    size.sizes.international}</span
                                >
                                <span
                                  aria-hidden="true"
                                  class="pointer-events-none absolute -inset-px rounded-md border-2 border-gray-200"
                                >
                                  <svg
                                    class="absolute inset-0 h-full w-full stroke-2 text-gray-200"
                                    viewBox="0 0 100 100"
                                    preserveAspectRatio="none"
                                    stroke="currentColor"
                                  >
                                    <line
                                      x1="0"
                                      y1="100"
                                      x2="100"
                                      y2="0"
                                      vector-effect="non-scaling-stroke"
                                    />
                                  </svg>
                                </span>
                              </label>

                              <!-- <button
                                on:click|stopPropagation|preventDefault={() => {
                                  AddWatchList(item.id);
                                }}
                                class="w-full mt-10 mb-4 md:h-12 h-10 border-solid border-1 hover:bg-custom-gray3 hover:text-custom-white-bg md:py-[14px] py-[8px] text-[10px] font-semibold text-center"
                              >
                                в лист ожидания
                              </button> -->
                            </div>
                          {/if}
                        {/each}
                      </div>
                    </fieldset>
                    {#if item.get_sizes_origin_product.filter((el) => el.total === 0).length > 0}
                      <div class="relative">
                        <div
                          class="absolute inset-0 flex items-center"
                          aria-hidden="true"
                        >
                          <div class="w-full border-t border-gray-300" />
                        </div>
                        <div class="relative flex justify-center">
                          <span class="bg-white px-2 text-sm text-gray-500"
                            >Лист ожидания</span
                          >
                        </div>
                      </div>
                    {/if}

                    <fieldset class="mt-4">
                      <legend class="sr-only">Choose a size</legend>
                      <div class="grid grid-cols-3 gap-4">
                        <!-- Active: "ring-2 ring-indigo-500" -->
                        {#each item.get_sizes_origin_product as size}
                          {#if size.total === 0}
                            <button
                              on:click|stopPropagation|preventDefault={() => {
                                AddWatchList(item.id);
                              }}
                              class="inline-flex items-center gap-x-1.5 rounded-md bg-gray-500 px-3 py-2 text-[10px] font-semibold text-white shadow-sm hover:bg-gray-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-500"
                            >
                              <svg
                                class="-mr-0.5 size-5"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                                aria-hidden="true"
                                data-slot="icon"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z"
                                  clip-rule="evenodd"
                                />
                              </svg>
                              {size.sizes.european || size.sizes.international} в
                              лист ожидания
                            </button>
                          {/if}
                        {/each}
                      </div>
                    </fieldset>
                  </div>

                  <button
                    type="submit"
                    class="mt-6 flex w-full bg-[#3D3D3D] items-center justify-center rounded-md border border-transparent px-8 py-3 text-base font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2"
                  >
                    В корзину
                  </button>
                </form>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
